import React from 'react';
import PropTypes from 'prop-types';

import PresenceAvatar from '@ciscospark/react-container-presence-avatar';

import classNames from 'classnames';

import styles from './styles.css';

const propTypes = {
  avatarId: PropTypes.string,
  isTyping: PropTypes.bool,
  name: PropTypes.string.isRequired
};

const defaultProps = {
  avatarId: '',
  isTyping: false
};

function TypingAvatar({avatarId, isTyping, name}) {
  return (
    <div className={classNames('ciscospark-typing-avatar', styles.typingAvatar)} data-tooltip={name}>
      <div className={classNames('ciscospark-avatar', styles.avatar)}>
        <PresenceAvatar avatarId={avatarId} isTyping={isTyping} name={name} size="24" />
      </div>
    </div>
  );
}

TypingAvatar.propTypes = propTypes;
TypingAvatar.defaultProps = defaultProps;

export default TypingAvatar;
